// import React, { useState } from 'react';
// // FIX: Removed 'Gas' which caused an error and replaced it with 'Flame' for the gas bill icon.
// import { Home, Zap, ShoppingCart, User, Bell, Upload, Calendar, ShoppingBag, Droplet, Wifi, Tv, ArrowLeft, Cloud, CheckSquare, Settings, CreditCard, HelpCircle, Smartphone, Flame } from 'lucide-react';
// import Gas from '../../assets/bill/Flame.svg'
// import TV from '../../assets/bill/TV.svg'
// import Internet from '../../assets/bill/Wifi_High.svg'
// import Water from '../../assets/bill/drop.svg'
// import Electricity from '../../assets/bill/lamp-charge.svg'
// import Mobile from '../../assets/bill/iPhone.svg'
// // --- Global UI Constants ---
// // Colors matched to the screenshots (light blue/purple gradient and dark blue primary text)
// const PRIMARY_TEXT = '#1e293b'; // Dark Slate Blue for headings
// const ACCENT_COLOR = '#4f46e5'; // Indigo/Blue for accents
// const LIGHT_BLUE_BG = '#eef2ff'; // Very light blue background shade

// // Placeholder for the custom illustrative icons (using Lucide icons and rounded bg styles)
// const IconPlaceholder = ({ icon: Icon, bgColor, textColor, size = 6 }) => (
//     <div className={`p-3 rounded-full flex items-center justify-center`} style={{ backgroundColor: bgColor, color: textColor }}>
//         <Icon className={`w-${size} h-${size}`} />
//     </div>
// );
// const PayBillScreen = ({setActiveScreen}) => {
//     // Mock data for bill categories (Matching icons/labels from Pay Bill.png)
//     const categories = [
//         { icon: Electricity, label: 'Electricity' },
//         { icon: Gas, label: 'Gas' }, // Using 'Flame' to represent gas/fuel
//         { icon: Internet, label: 'Internet' },
//         { icon: Water, label: 'Water' },
//         { icon: Mobile, label: 'Mobile Recharge' },
//         { icon: TV, label: 'DTH/Cable TV' },
//     ];

//     // Bill Category Item Component
//     const BillCategoryItem = ({ icon, label }) => (
//         <button className="flex flex-col items-center w-full p-2 focus:outline-none group">
//             <div className="p-4 bg-white border border-gray-100 rounded-xl shadow-md group-hover:border-blue-500 group-hover:shadow-lg transition-all duration-200" onClick={()=>{
//                     setActiveScreen('paymentebill')
//                 }} >
//                 <img src={icon} className="w-6 h-6 text-gray-700 group-hover:text-blue-600 transition-colors" />
//             </div>
//             <span className="mt-2 text-xs font-medium text-gray-600 group-hover:text-blue-700">{label}</span>
//         </button>
//     );

//     // Using the same topups data for consistency
//     const topups = [
//         { amount: '150 kWh', date: '10 Oct 2025', cost: '-₦25,000', status: 'Successful', statusColor: '#059669' },
//         { amount: '150 kWh', date: '10 Oct 2025', cost: '-₦25,000', status: 'Successful', statusColor: '#059669' },
//     ];


//     return (
//         <div className="p-4 bg-gray-50 flex-1 overflow-y-auto">
//              {/* Top Header (Back Button and Title) */}
//             <header className="flex items-center space-x-4 mb-8 pt-2">
//                 <button className="p-1 text-gray-700 hover:text-gray-900">
//                     <ArrowLeft className="w-6 h-6" />
//                 </button>
//                 <h1 className="text-xl font-semibold text-gray-900 flex-1 text-center pr-8">Pay Bill</h1>
//             </header>

//             {/* Bill Categories Section (White Card) */}
//             <div className="bg-white p-5 rounded-3xl shadow-lg mb-8">
//                 <h2 className="text-lg font-semibold text-gray-800 mb-6">Select Bill Type</h2>

//                 {/* Grid layout matching Pay Bill.png (3 columns, 2 rows) */}
//                 <div className="grid grid-cols-3 gap-y-6 gap-x-3">
//                     {categories.map((category, index) => (
//                         <BillCategoryItem key={index} icon={category.icon} label={category.label} />
//                     ))}
//                 </div>
//             </div>

//             {/* Recent Topups Section */}
//             <div className="px-1">
//                 <div className="flex justify-between items-center mb-4">
//                     <h2 className="text-lg font-bold text-gray-800">Recent Topups</h2>
//                     <button className="text-blue-600 text-sm font-semibold hover:text-blue-700">See all</button>
//                 </div>

//                 {/* Topup List Items */}
//                 <div className="space-y-4">
//                     {topups.map((topup, index) => (
//                         <div key={index} className="flex items-center justify-between bg-white p-4 rounded-xl shadow-md border border-gray-100">
//                             <div className="flex items-center space-x-3">
//                                 {/* Small Icon Placeholder (K Logo) */}
//                                 <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center border border-orange-300">
//                                     <span className="font-extrabold text-lg text-orange-600">K</span>
//                                 </div>
//                                 <div>
//                                     <p className="font-semibold text-gray-800">{topup.amount}</p>
//                                     <p className="text-xs text-gray-500">{topup.date}</p>
//                                 </div>
//                             </div>
//                             <div className="text-right">
//                                 <p className="font-bold text-sm text-red-600">{topup.cost}</p>
//                                 <p className="text-xs font-semibold" style={{ color: topup.statusColor }}>{topup.status}</p>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//             {/* Spacer for bottom navigation */}
//             <div className="h-20"></div>
//         </div>
//     );
// };


// export default PayBillScreen;



import React, { useState, useEffect, useCallback } from 'react';
import {
    ArrowLeft, Loader2, Zap, // Existing imports
    Lightbulb, Tv, Landmark, Smartphone, Heart, Phone, Wifi, Plane, Bus, ShoppingBag,
    Wallet, Scale, Shield, Users, Ticket, Briefcase, Banknote, DollarSign, Church, Gamepad,
    ChevronLeft
} from 'lucide-react'; // 🚨 NEW ICON IMPORTS
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config/api';
// import { useAndroidBackHandler } from '../../hooks/androidbackHandler';

// API URL for Bill Categories
const CATEGORIES_API_URL = `${API_BASE_URL}/utility-transactions/categories`;

// Map API Category Names to Lucide Icon Components
const CATEGORY_ICON_MAP = {
    "Utility Bills": Lightbulb, // Electricity, Water, Gas
    "Cable TV Bills": Tv,
    "State Payments": Landmark, // Taxes, Government fees
    "Mobile/Recharge": Smartphone, // Mobile top-up
    "Donations": Heart,
    "Phone Bills": Phone, // Post-paid phone bills
    "Subscriptions": Wifi, // ISP, Streaming, etc.
    "Embassy Payments": Landmark, // Reusing Landmark for government/official
    "Tax Payments": Scale,
    "Insurance/Smart": Shield,
    "Others": Users, // General fallback icon
    "Airlines": Plane,
    "Transport": Bus,
    "Products and Services": ShoppingBag,
    "Funds Transfer": DollarSign,
    "Microfinance": Banknote,
    "Mobile Money": Wallet,
    "PayChoice": Briefcase, // Assuming business/school payments
    "Event Tickets": Ticket,
    "Quickteller Business": Briefcase,
    "Transfer Money": DollarSign,
    "Receive Money": DollarSign,
    "Religious Institutions": Church,
    "Betting, Lottery and Gaming": Gamepad,
    // Add more mappings if needed
};

const getIconForCategory = (categoryName) => {
    // Return the specific icon or a default one (e.g., Users or Wallet)
    return CATEGORY_ICON_MAP[categoryName] || Users;
};
// Component receives authToken via props
const PayBillScreen = ({ setActiveScreen, onBack, authToken,handleSignOut }) => { // 🚨 authToken ADDED HERE

    //    const handleNativeBack = () => {
    //         // This is the same function passed as 'onBack' prop
    //         onBack(); 
    //     };

    //     // Apply the hook with the custom action
    //     useAndroidBackHandler(handleNativeBack);

    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);


    const navigate = useNavigate()
    // Mock data for recent topups
    const topups = [
        { amount: '150 kWh', date: '10 Oct 2025', cost: '-₦25,000', status: 'Successful', statusColor: '#059669' },
        { amount: '50 GB', date: '05 Dec 2025', cost: '-₦5,000', status: 'Successful', statusColor: '#059669' },
    ];
    // --- Data Fetching Logic (Moved outside useEffect and wrapped in useCallback) ---
    const fetchCategories = useCallback(async () => {
        if (!authToken) {
            setError('Authentication token is missing. Cannot load categories.');
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(CATEGORIES_API_URL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
            });
            if (response.status === 401) {
                // 🚨 SESSION INVALID
                // forceLogout("You were logged out because your account was used on another device.");
                handleSignOut()
                return;
            }

            if (!response.ok) {
                const errorDetail = await response.json();
                throw new Error(`Failed to load categories. Status: ${response.status}. Detail: ${errorDetail.message || response.statusText}`);
            }

            const result = await response.json();

            if (result.status === "SUCCESS" && Array.isArray(result.data.categories)) {
                setCategories(result.data.categories);
            } else {
                // Handle API errors where HTTP status is 200 but API status is not success
                throw new Error(result.message || 'API response format error.');
            }
        } catch (err) {
            console.error('Failed to fetch categories:', err);
            setError(err.message || 'Network error while fetching categories.');
            setCategories([]);
        } finally {
            setIsLoading(false);
        }
    }, [authToken,handleSignOut]); // Dependency: Function must re-create if authToken changes

    // --- Effect to trigger initial fetch on mount ---
    useEffect(() => {
        // Now we can safely call fetchCategories() here
        fetchCategories();
    }, [fetchCategories]); // Dependency: fetchCategories must be included





    // --- Component for a Single Bill Category ---
    const BillCategoryItem = ({ icon: IconComponent, categoryName, categoryId }) => (
        <button
            className="flex flex-col items-center w-full p-2 focus:outline-none group"
            onClick={() => {
                // Pass the correct ID and Name to the next screen
                setActiveScreen('paymentebill', { categoryId: categoryId, categoryName: categoryName });
            }}
        >
            <div className="p-4 bg-white border border-gray-100 rounded-xl shadow-md group-hover:border-blue-500 group-hover:shadow-lg transition-all duration-200">
                {/* iconUrl usage remains the same */}
                {/* <img
                    src={iconUrl}
                    alt={categoryName}
                    className="w-6 h-6 object-contain"
                    onError={(e) => { e.target.onerror = null; e.target.src = "https://via.placeholder.com/24" }}
                /> */}
                <IconComponent className="w-6 h-6 text-blue-600" />
            </div>
            <span className="mt-2 text-xs font-medium text-gray-600 group-hover:text-blue-700">{categoryName}</span>
        </button>
    );

    // --- Main Render Function (Loading/Error handling improved) ---
    return (
        <div className="p-4 bg-gray-50 flex-1 overflow-y-auto">
            {/* ... Header remains unchanged ... */}
            <header className="flex items-center space-x-4 mb-8 pt-2">
                <button className="p-1 text-gray-700 hover:text-gray-900" onClick={() => onBack ? onBack() : setActiveScreen('home')}>
                    <ChevronLeft className="w-6 h-6" />
                </button>
                <h1 className="text-xl font-semibold text-gray-900 flex-1 text-center pr-8">Pay Bill</h1>
            </header>

            <div className="bg-white p-5 rounded-3xl shadow-lg mb-8">
                <h2 className="text-lg font-semibold text-gray-800 mb-6">Select Bill Type</h2>

                {isLoading && (
                    <div className="flex justify-center items-center py-10">
                        <Loader2 className="w-8 h-8 text-blue-600 animate-spin mr-2" />
                        <span className="text-gray-600">Loading categories...</span>
                    </div>
                )}

                {error && !isLoading && (
                    <div className="text-center py-10 text-red-600 font-medium p-4 bg-red-50 rounded-lg">
                        <Zap className="w-6 h-6 mx-auto mb-2" />
                        {error}
                        {/* Option to retry fetch if there's an error */}
                        <button onClick={() => fetchCategories()} className="mt-2 text-blue-600 underline text-sm">Retry Load</button>
                    </div>
                )}

                {!isLoading && !error && categories.length > 0 && (
                    <div className="grid grid-cols-3 gap-y-6 gap-x-3">
                        {categories.map((category) => (
                            <BillCategoryItem
                                key={category.Id}
                                icon={getIconForCategory(category.Name)}
                                categoryName={category.Name} // 
                                categoryId={category.Id}
                            />
                        ))}
                    </div>
                )}

                {!isLoading && !error && categories.length === 0 && (
                    <div className="text-center py-10 text-gray-500">
                        No bill categories available at this time.
                    </div>
                )}
            </div>

            {/* Recent Topups Section (Unchanged) */}
            <div className="px-1">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-bold text-gray-800">Recent Topups</h2>
                    <button className="text-blue-600 text-sm font-semibold hover:text-blue-700">See all</button>
                </div>

                {/* Topup List Items */}
                <div className="space-y-4">
                    {topups.map((topup, index) => (
                        <div key={index} className="flex items-center justify-between bg-white p-4 rounded-xl shadow-md border border-gray-100">
                            {/* ... (Topup details rendering) ... */}
                            <div className="flex items-center space-x-3">
                                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center border border-orange-300">
                                    <span className="font-extrabold text-lg text-orange-600">K</span>
                                </div>
                                <div>
                                    <p className="font-semibold text-gray-800">{topup.amount}</p>
                                    <p className="text-xs text-gray-500">{topup.date}</p>
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="font-bold text-sm text-red-600">{topup.cost}</p>
                                <p className="text-xs font-semibold" style={{ color: topup.statusColor }}>{topup.status}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Spacer for bottom navigation */}
            <div className="h-20"></div>
        </div>
    );
};


export default PayBillScreen;

